import { useAtomValue } from "jotai";

import { Paragraph, qmIdAtom } from "@ms/gatsby-theme";

import type { FC } from "react";

/**
 * Footer QM ID
 *
 * This component adds a condensed quantum metric id to help debugging
 * we only show first 4 and last 4 characters ie "d2aa-e73e"
 */
export const FooterQmId: FC = () => {
  const qmId = useAtomValue(qmIdAtom);

  return (
    <Paragraph
      data-id="qm-footer-id"
      sx={{
        fontSize: "fs12",
        color: "grey300",
        textAlign: "center",
        pb: ["s700", null, "s900"],
      }}
    >
      {qmId}
    </Paragraph>
  );
};
